import React, { useState } from "react";
import { useAuthDataContext } from "components/auth";
import { useCurrentCustomerContext } from "components/current-customer-context";
import Dashboard from "components/dashboard";
import ValidatedForm from "components/form";
import { PageHeaderBar } from "components/page";
import { EventFormProvider, useEventFormContext } from "pages/event/forms/utils";
import { handleEventSubmitError } from "pages/event/utils";
import { validationSchema, getDefaultValues, handleSubmit, NewEventForm } from "./forms/new-form";
import { useLoadingContext } from "../../components/loading-spinner-overlay";

const NewForm = ({ intl, history }) => {
  const { setLoading } = useLoadingContext();
  const { hasAdminPrivileges, user } = useAuthDataContext();
  const [hasRoomTemplates, setHasRoomTemplates] = useState(false);
  const [isSportEvent, setSportEvent] = useState(false);
  const { currentCustomerId, contracts } = useCurrentCustomerContext();
  const { showSportDataConfig } = useEventFormContext();
  const [showLocalRecEventFields, setShowLocalRecEventFields] = useState(false);

  if (!contracts) {
    setLoading(true);
    return null;
  } else {
    setLoading(false);
  }

  return (
    <ValidatedForm
      reloadOnNewInitialValues={false}
      initialValues={getDefaultValues({
        hasAdminPrivileges,
        isSportEvent,
        userEmail: user.email,
        userLocale: user.locale,
        ...(contracts?.length === 1 && { contractId: contracts[0]._id }),
        ...(contracts?.length === 1 && { customerId: contracts[0].customer_id }),
      })}
      validationSchema={validationSchema({
        intl,
        hasAdminPrivileges,
        hasRoomTemplates,
        isSportEvent,
        showSportDataConfig,
        showLocalRecEventFields,
      })}
      onSubmit={handleSubmit({ history, hasAdminPrivileges, currentCustomerId, user })}
      onSubmitError={handleEventSubmitError(intl)}
    >
      {props => {
        return (
          <NewEventForm
            isSportEvent={isSportEvent}
            setSportEvent={setSportEvent}
            setHasRoomTemplates={setHasRoomTemplates}
            showLocalRecEventFields={showLocalRecEventFields}
            setShowLocalRecEventFields={setShowLocalRecEventFields}
            {...props}
          />
        );
      }}
    </ValidatedForm>
  );
};

const EventNewPage = ({ intl, history }) => {
  return (
    <Dashboard>
      <EventFormProvider>
        <PageHeaderBar title="app.page.event.new" />
        <NewForm intl={intl} history={history} />
      </EventFormProvider>
    </Dashboard>
  );
};

export default EventNewPage;
